import {upperCase} from 'lodash';

const CYRILLIC_LATIN_MAP = {
    'А': 'A', 'а': 'A',
    'В': 'B', 'в': 'B',
    'С': 'C', 'с': 'C',
    'Е': 'E', 'е': 'E',
    'Н': 'H', 'н': 'H',
    'К': 'K', 'к': 'K',
    'М': 'M', 'м': 'M',
    'О': 'O', 'о': 'O',
    'Р': 'P', 'р': 'P',
    'Т': 'T', 'т': 'T',
    'У': 'Y', 'у': 'Y',
    'Х': 'X', 'х': 'X',
    'Д': 'D', 'д': 'D',
    'Ф': 'F', 'ф': 'F',
    'Г': 'G', 'г': 'G',
    'И': 'I', 'и': 'I',
    'Л': 'L', 'л': 'L',
    'З': 'Z', 'з': 'Z',
};

const mapToLatin = (value) => String(value ?? '')
    .split('')
    .map((char) => CYRILLIC_LATIN_MAP[char] ?? char)
    .join('');

export const toUpperLatinLetters = (value) =>
    upperCase(mapToLatin(value)).replace(/[^A-Z]/g, '');

export const toUpperLatinAlphanumeric = (value) =>
    upperCase(mapToLatin(value)).replace(/[^A-Z0-9]/g, '');
